<template>
    <div class="fullwidth">
        <div role="alert" class="alert mb-4" :class="alertClass" v-show=hideMessage>
            <div class="container">
                <div class="alert-header">
                    <checkmark class="svg-36 mr-2" v-if="message.level == 'success'"></checkmark>
                    <info class="svg-36 mr-2"  v-if="(message.level != 'success' && message.level != 'danger')"></info>
                    <warning class="svg-36 mr-2"  v-if="message.level == 'danger'"></warning>
                    <div class="message-wrapper">
                        <h2 v-html="message.message"></h2>
                    </div>
                    <div class="close-icon-right"  @click="hideMessage = false">
                        <closeicon class="svg-36"></closeicon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import closeicon from '../Icons/circle_close.vue';
import warning from '../Icons/warning.vue';
import info from '../Icons/info.vue';
import checkmark from '../Icons/checkmark.vue';

export default {
    props: ['message'],
    components: {closeicon, warning, info, checkmark},
    data() {
        return {
            hideMessage: true,
            alertClass: 'blue'
        }
    },
    created: function() {
        this.alertClass = 'mb-4 alert alert-' + this.message.level;
    }
}
</script>
